import { createSelector, Selector } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';

interface CreatedAtParams {
  createdAtStart: string | undefined;
  createdAtEnd: string | undefined;
}

export const getAdjustedFiltersForSelectors = <T extends CreatedAtParams>(
  selectors: Selector[],
) => {
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  return createSelector(selectors, (filters: T) => {
    if (filters.createdAtStart != null && filters.createdAtEnd != null) {
      return filters;
    }

    const now = DateTime.local();
    const startOfDay = now.startOf('day');
    const endOfDay = startOfDay.endOf('day');
    const startTimeRange = startOfDay.minus({ days: 14 });
    return {
      ...filters,
      createdAtStart: startTimeRange.toUTC().toISO(),
      createdAtEnd: endOfDay.toUTC().toISO(),
    };
  });
};
